import { defaultCurrency, paymentTypes } from '~/config/constant'
import { STATUS_CODE } from '~/constants'

import request from './request'
import { MERCHANT_TYPE } from '~/constants/restaurant'
import STORAGE_KEYS from '~/constants/localStorage'
import { ENDPOINT } from './endPoint'
import { DEFAULT_FORMAT_PRICE } from '~/constants/currency'

// LIST BANNER
export const getListBannerApi = async (storeId) => {
  const URL = `restaurants/${storeId}/banners`
  const params = {}
  params.limit = 20

  try {
    const { data, status } = await request().get(URL, { params })
    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data.data || [],
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      data: [],
    }
  }
}

// LIST CATEGORY
export const getListCategoryApi = async (id, bigCategoryId, limit = 1000, page) => {
  const URL = `restaurants/${id}/food_categories`
  const params = {}
  params.limit = limit // hiện tại thì để 1000 vì mong muốn show tất
  if (page) params.page = page
  if (bigCategoryId) params.big_category_id = bigCategoryId

  try {
    const { data, status } = await request().get(URL, { params })
    if (status === STATUS_CODE.NUM_SUCCESS) {
      return {
        isSuccess: true,
        data: data.data || [],
        paging: data?.paging || {},
      }
    }
  } catch (error) {
    return {
      isSuccess: false,
      data: [],
    }
  }
}

// Hàm này dùng chung ở nhiều chỗ
export const getInfoRestaurantApi = async ({ restaurantSlug, tableUid }, { rejectWithValue }) => {
  const params = {}
  if (restaurantSlug) params.restaurant_slug = restaurantSlug
  if (tableUid) params.table_uuid = tableUid

  const URL = ENDPOINT.CURRENT_INFO

  try {
    const response = await request().get(URL, { params })

    const { restaurant, table, session, serving_token } = response?.data?.data

    if (Number(session?.number_of_people) > 0) {
      localStorage.setItem(STORAGE_KEYS.NUMBER_OF_PEOPLE, Number(session?.number_of_people))
    }

    return {
      isSuccess: true,
      restaurantId: restaurant.id,
      restaurantSlug: restaurantSlug || restaurant.slug || '',
      restaurantName: restaurant.name || '',
      tableId: table?.id || null,
      tableUid: tableUid || table?.uuid || null,
      tableName: table?.name || '',
      vatPercent: restaurant.vat_rate,
      serviceRate: restaurant.service_rate,
      menuExcludesVAT: restaurant.menu_excluded_vat,
      homeTemplateId: restaurant.homepage_template, // template hiện tại màn hình home
      extraFeatures: restaurant.extra_feature_names, // danh sách các chức năng mà nhà hàng đăng ký
      logoTopPage: restaurant.logo_top_page,
      logoHomePage: restaurant.logo_home_page,
      line_page_url: restaurant.line_page_url,
      supportLang: restaurant.support_languages,
      theme: restaurant.theme,
      externalPartner: restaurant.external_partner,
      currency: restaurant.currency || defaultCurrency,
      capichi_delivery_following: restaurant?.capichi_delivery_following || false,
      allow_order: table?.allow_order,
      deeplink_store_on_delivery: restaurant?.deeplink_store_on_delivery || '',
      merchant_type: restaurant?.merchant_type || MERCHANT_TYPE.RESTAURANT,
      paymentType: restaurant?.payment_type || paymentTypes.pay_after_receive,
      number_of_people: session?.number_of_people || null,
      food_court_id: restaurant?.food_court_id || null,
      food_court_slug: restaurant?.food_court_slug || '',
      order_code: session?.order_code || '',
      google_map_url: restaurant.google_map_url || '',
      tripadvisor_url: restaurant.tripadvisor_url || '',
      instagram_url: restaurant.instagram_url || '',
      timezone: restaurant.timezone || '',
      banner_promote_delivery: restaurant.banner_promote_delivery,
      separate_order: table?.separate_order || false,
      food_court_partner: restaurant.food_court_partner || '',
      phone: serving_token?.phone || '',
      buffet_requests_time: session?.buffet_requests_time || [],
      linkage_requests_time: session?.linkage_requests_time || [],
      price_format: restaurant.price_format || DEFAULT_FORMAT_PRICE,
      country: restaurant.country,
    }
  } catch (err) {
    const { status, data } = err?.response ?? {}
    if (!rejectWithValue) {
      return { isSuccess: false, status, data }
    }
    return rejectWithValue({ status, data })
  }
}
